import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';
import { apiClient } from '../api/client';
import { PageLoadingSpinner } from './ui/LoadingSpinner';

interface PrivateRouteProps {
  children: React.ReactNode;
}

// Using shared LoadingSpinner component

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, authState, isLoading, authFailed } = useAuth();
  const location = useLocation();

  // Show loading state while auth is initializing
  if (isLoading) {
    // Auth is loading
    return <PageLoadingSpinner />;
  }

  // If auth has failed or we have no tokens, redirect to login
  if (authFailed || (!apiClient.getAuthToken() && !localStorage.getItem('refresh_token'))) {
    // Auth failed or no tokens, redirecting to login
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // If we have a valid auth state, render the protected route
  if (authState.id > 0) {
    // Auth valid, rendering route
    return <>{children}</>;
  }

  // If we have tokens but no valid auth yet, keep showing loading
  if ((apiClient.getAuthToken() || localStorage.getItem('refresh_token')) && authState.id === 0) {
    // Has tokens but no auth state yet, showing loading
    return <PageLoadingSpinner />;
  }

  // No tokens and no auth state, redirect to login
  // No tokens and no auth state, redirecting to login
  return <Navigate to="/auth/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
